import { AutopilotTaskDto } from '@urbanx/agx.activities.client';
import { CampaignDetailModel } from '@urbanx/agx.campaigns.client';
import TaskModalShell from './TaskModalShell';
import { useAgreementComplianceModal } from './useAgreementComplianceModal';

interface AgreementComplianceModalProps {
  campaignId: string;
  campaign: CampaignDetailModel;
  isOpen: boolean;
  onClose: () => void;
  onCompleteSuccess?: () => void;
  task: AutopilotTaskDto;
}

const OpenAgreementComplianceModal = ({
  campaignId,
  campaign,
  isOpen,
  onClose,
  onCompleteSuccess,
  task,
}: AgreementComplianceModalProps) => {
  const controller = useAgreementComplianceModal({
    campaignId,
    campaign,
    isOpen,
    task,
  });

  return (
    <TaskModalShell
      title={'Agreement Compliance'}
      tasks={[task]}
      open={isOpen}
      onClose={onClose}
      campaignId={campaignId}
      campaign={campaign}
      {...controller}
      onCompleteSuccess={onCompleteSuccess}
      hideCloseButton
      previousButtonText="Previous"
      presentationClassName="taskModal--agreementCompliance"
      modalId="agreement-compliance-task-modal"
    />
  );
};

const AgreementComplianceModal = (props: AgreementComplianceModalProps) => {
  if (!props.isOpen) return null;

  return <OpenAgreementComplianceModal {...props} />;
};

export default AgreementComplianceModal;
